import { environment } from 'src/environments/environment';
import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
//[PrimeNG]
import { MessageService } from 'primeng/api';
// [[Providers]]
import { CustomerUserService } from 'src/project/services/panel/client/marketplace/customer/user/user.service';
import { CollectiveMarketplaceService } from '~services/collective/client/marketplace/marketplace.service';
import { CollectiveMarketplaceCartService } from '~services/collective/client/marketplace/cart/cart.service';
import { CollectiveMarketplaceCoreVisualBannerService } from '~services/collective/client/marketplace/core/visual/banner/banner.service';

import { ClientMarketplaceCoreProductService } from '~services/collective/client/marketplace/core/product/product.service';
import { ClientMarketplaceCartProductService } from '~services/collective/client/marketplace/cart/product/product.service';
// ]
// [[Interfaces/Models do Componente]]

// ]
@Component({
  selector: 'app',
  templateUrl: './component.html',
  styleUrls: ['./component.scss'],
})
export class CartViewComponent implements OnInit {
  /**
   * Base de uso em Component
   */
  public environment = environment;
  messageProcess = false;
  messageIsError: any;
  profile: any;
  marketplace: any = null;
  cart: any = null;
  banners: any = null;
  banners_fnc_cta: any = null;
  displayModal: boolean;

  constructor(
    /**
     * Serviços da Aplicação
     */
    private titleService: Title,
    private messageService: MessageService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    /**
     * Base de uso em Component
     */
    private userService: CustomerUserService,
    private collectiveMarketplaceService: CollectiveMarketplaceService,
    private collectiveMarketplaceCartService: CollectiveMarketplaceCartService,
    private collectiveMarketplaceCoreVisualBannerService: CollectiveMarketplaceCoreVisualBannerService,

    private clientMarketplaceCoreProductService: ClientMarketplaceCoreProductService,
    private clientMarketplaceCartProductService: ClientMarketplaceCartProductService
  ) {}

  ngOnInit() {
    this.ipBuildEcommerceDependencies();
    this.collectiveMarketplaceCartServiceShow();
  }

  /**
   * build ecommerce dependencies
   */
  ipBuildEcommerceDependencies() {
    /**
     * Base
     *
     * Request da base de uso.
     */
    // PROFILE
    this.userService.getUser().subscribe((Profile: any) => {
      if (Profile != null) {
        if (JSON.parse(Profile) != null) {
          this.profile = JSON.parse(Profile);
        }
      }
    });
    // MARKETPLACE
    this.collectiveMarketplaceService.getMarketplace().subscribe((Marketplace: any) => {
      if (Marketplace != null) {
        if (JSON.parse(Marketplace) != null) {
          this.marketplace = JSON.parse(Marketplace);
          /**
           *
           * CONFIGURAÇÕES ADICIONAIS DESTE `COMPONENTE`
           *
           */
          // SEO
          this.titleService.setTitle(this.marketplace.name);
        }
      }
    });
    // BANNERS
    this.banners_fnc_cta = function (banner: any) {
      if (banner.url != '') {
        document.location = banner.url;
      }
      return false;
    };
    this.collectiveMarketplaceCoreVisualBannerService.getBanners().subscribe((Data: any) => {
      if (Data != null) {
        if (JSON.parse(Data) != null) {
          this.banners = JSON.parse(Data);
        }
      }
    });
  }

  ngOnDestroy() {}

  /**
   * Collectives marketplace cart service show
   */
  collectiveMarketplaceCartServiceShow(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      const uid = params['uid'];
      const _ = this.collectiveMarketplaceCartService.view({ client_marketplace_cart_uid: uid });
      if (_ !== null) {
        _.subscribe(
          (response: any) => {
            this.cart = response.data;
            /* Checking if the cart is not in the shopping status, if it is not, it will redirect to
            the order page. */
            if (this.cart.client_marketplace_cart_status != 'shopping') {
              document.location.href = '/a/order';
            }
            /* It's a flag to show the user that the request is being processed. */
            this.messageProcess = false;
          },
          (err) => {
            if (err.error.errors) {
              for (let error in err.error.errors) {
                this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
                this.messageProcess = false;
                this.messageIsError = this.collectiveMarketplaceCartService.error.throw(error);
              }
            }
          }
        );
      }
    });
  }

  price_delivery: any;
  @ViewChild('zipcode', { static: false }) zipcode: ElementRef;
  /**
   * Clients marketplace cart service price delivery
   */
  collectiveMarketplaceCartServicePriceDelivery() {
    var _ = this.collectiveMarketplaceCartService.price_delivery({ client_marketplace_cart_uid: this.cart.client_marketplace_cart_uid, zipcode: this.zipcode.nativeElement.value });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.price_delivery = response.data;
          this.displayModal = true;
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.collectiveMarketplaceCartService.error.throw(error);
            }
          }
        }
      );
    }
  }

  showModalDialog() {
    this.displayModal = true;
  }

  /**
   * Clients marketplace cart service delivery method
   * @param delivery
   */
  collectiveMarketplaceCartServiceApplyDeliveryMethod(delivery: any) {
    /* It's a function that will be called when the user click on the button `Aplicar Cupom` */
    var _ = this.collectiveMarketplaceCartService.apply_delivery_method({
      client_marketplace_cart_uid: this.cart.client_marketplace_cart_uid,
      client_marketplace_core_delivery_id: delivery.id,
      zipcode: this.zipcode.nativeElement.value,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.cart = response.data;
          this.price_delivery = {};
          this.displayModal = false;
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.collectiveMarketplaceCartService.error.throw(error);
            }
          }
        }
      );
    }
  }

  voucher: any;
  /**
   * Clients marketplace cart service voucher
   */
  collectiveMarketplaceCartServiceVoucher() {
    var _ = this.collectiveMarketplaceCartService.apply_voucher_when_is_possible({
      client_marketplace_cart_uid: this.cart.client_marketplace_cart_uid,
      voucher: this.voucher,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          var cart = response.data;
          /* It's a function that will be called when the user click on the button `Aplicar Cupom` */
          if (cart.voucher == null) {
            this.messageService.add({ severity: 'error', detail: 'Não foi possível aplicar o cupom informado aos produtos do seu carrinho.' });
          } else {
            this.messageService.add({ severity: 'success', summary: 'Cupom aplicado à sua compra', detail: 'Verifique os produtos que possuem disponibilidade de uso para o CUPOM informado.' });
          }
          this.collectiveMarketplaceCartServiceShow();
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.collectiveMarketplaceCartService.error.throw(error);
            }
          }
        }
      );
    }
  }

  /**
   * Clients marketplace cart product service update less product
   * @param product
   */
  clientMarketplaceCartProductServiceUpdateLessProduct(product: any) {
    if (!this.messageProcess) {
      product.inventory_quantity = product.inventory_quantity - 1;
      this.clientMarketplaceCartProductServiceUpdate(product);
    }
  }

  /**
   * Clients marketplace cart product service update more product
   * @param product
   */
  clientMarketplaceCartProductServiceUpdateMoreProduct(product: any) {
    if (!this.messageProcess) {
      product.inventory_quantity = product.inventory_quantity + 1;
      this.clientMarketplaceCartProductServiceUpdate(product);
    }
  }

  /**
   * Clients marketplace cart product service update
   * @param product
   */
  clientMarketplaceCartProductServiceUpdate(product: any) {
    this.messageProcess = true;

    var _ = this.clientMarketplaceCartProductService.update(product);
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.collectiveMarketplaceCartServiceShow();
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.clientMarketplaceCartProductService.error.throw(error);
            }
          }
        }
      );
    }
  }

  /**
   * Clients marketplace cart product service destroy
   * @param product
   */
  clientMarketplaceCartProductServiceDestroy(product: any) {
    this.messageProcess = true;

    var _ = this.clientMarketplaceCartProductService.destroy(product);
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.collectiveMarketplaceCartServiceShow();
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.clientMarketplaceCartProductService.error.throw(error);
            }
          }
        }
      );
    }
  }
}
